import i18n from 'i18n-js';

const behaviour = ['manual', 'automatic'];

const types = ['DEFAULT', 'EXEMPT', 'PERLOCATION'];

const generateTaxTypes = (skipValues) =>
  types
    .filter((type) => skipValues.indexOf(type) === -1)
    .map((tax) => ({
      label: i18n.t(`skus.tax_types.${tax}`),
      value: tax,
    }));

export { behaviour, generateTaxTypes };
